import React from 'react'
import '../Home/Home/Home.css'
import { Container } from 'react-bootstrap'
const FooterSection = () => {
  return (
    <section className="_emtabout corp-hidden">
      <Container>
        <div className="_ininety">
          <div className="_Genttl">
            <span>
             Search Flights,Hotels and Holiday Packages
            </span>
          </div>
          <div className="_abt_txt">
            Discover your dream destinations with VolarPro expertly crafted holiday packages, designed to fit every traveller’s preferences, interests, and budget. Whether you're looking for adventure, relaxation, spiritual retreats, or romantic escapes, our itineraries promise an unforgettable experience from start to finish. With attention to every detail, VolarPro ensures that your journey is seamless, enriching, and memorable.
          </div>
          <div className="_Genttl">
            <span>
              Enjoy Hassle-Free Booking at the Best Prices &nbsp;
            </span> VolarPro
          </div>
          <div className="_abt_txt">
            Our easy-to-navigate platform allows you to explore a wide variety of holiday packages tailored to your travel needs. Whether you’re seeking a beachside escape, a hill station retreat, or a cultural expedition, VolarPro makes booking simple and stress-free. With a few clicks, you can lock in your ideal vacation—no lengthy searches or confusion, just straightforward and secure bookings.
          </div>
          <div className="_Genttl">
            <span>
              Unmatched Value with Every Package
            </span>
          </div>
          <div className="_abt_txt">
            Unlock exclusive deals and unbeatable offers with VolarPro competitive pricing and curated travel experiences. We combine comfort, quality, and affordability in all our packages—so whether you’re planning a family trip, a solo adventure, or a group tour, you’ll enjoy maximum value for your money. Take advantage of seasonal discounts and last-minute offers for a budget-friendly yet luxurious holiday.
          </div>
        </div>
      </Container>
    </section>

  )
}

export default FooterSection